import { useContext } from 'react';
import ToastContext from '../toast.context';
import { ToastContextProps } from '../types';

const useToast = (): { openToast: ToastContextProps['openToast'] } => {
  const context = useContext<ToastContextProps>(ToastContext);
  if (!context) {
    throw new Error('useToast must be used within a ToastContext Provider');
  }

  return {
    openToast: context.openToast,
  };
};

export default useToast;
